import { RECEIVE_META_NOTIFICATION, NotificationActionTypes } from './notificationTypes';
import { MetaNotification } from 'models/notification';

export function receiveMetaNotification(metaNotification: MetaNotification): NotificationActionTypes {
  return {
    type: RECEIVE_META_NOTIFICATION,
    metaNotification,
  };
}
